import { createTheme } from '@mui/material/styles'
import { alpha } from '@mui/material/styles'
import type { PaletteMode } from '@mui/material'

const primaryColor = '#708BC3'
const secondaryColor = '#90C5B6'

export const createMedicalTheme = (mode: PaletteMode = 'light') => {
  const objectiveTheme = createTheme({
    palette: {
      mode,
      action: {
        disabledBackground: alpha('#aaaaaa', 0.3),
      },
      primary: { main: primaryColor, contrastText: '#ffffff' },
      secondary: { main: secondaryColor },
    },
  })

  return createTheme(objectiveTheme, {
    components: {
      MuiCheckbox: {
        styleOverrides: {
          root: {
            height: '25px',
          },
        },
      },
      MuiAccordion: {
        styleOverrides: {
          root: {
            '&.Mui-expanded': {
              marginTop: '10px',
            },
            marginTop: '10px',
          },
        },
      },
      MuiAccordionDetails: {
        styleOverrides: {
          root: {
            paddingBottom: '5px',
            paddingLeft: '20px',
            paddingRight: '0px',
            paddingTop: '15px',
          },
        },
      },
      MuiAccordionSummary: {
        styleOverrides: {
          content: {
            '&.Mui-expanded': {
              margin: '2px 0',
            },
            margin: '2px',
          },
          root: {
            '&.Mui-expanded': {
              minHeight: '32px',
            },
            borderBottom: '2px',
            borderBottomColor: secondaryColor,
            borderBottomStyle: 'solid',
            marginBottom: -1,
            minHeight: '32px',
            paddingLeft: '10px',
          },
        },
      },
      MuiFormControlLabel: {
        styleOverrides: {
          label: {
            whiteSpace: 'nowrap',
          },
        },
      },
      MuiLink: {
        styleOverrides: {
          root: {
            whiteSpace: 'nowrap',
            cursor: 'pointer',
          },
        },
      },
      MuiMenuItem: {
        styleOverrides: {
          root: {
            '&:focus': {
              backgroundColor: alpha(primaryColor, 0.5),
            },
            '&:hover': {
              backgroundColor: alpha(primaryColor, 0.5),
            },
          },
        },
      },
      MuiOutlinedInput: {
        styleOverrides: {
          input: {
            padding: '8px',
          },
        },
      },
      MuiSelect: {
        styleOverrides: {
          select: {
            padding: '8px',
          },
        },
      },
      MuiTableCell: {
        styleOverrides: {
          root: {
            padding: '4px 14px 4px 12px',
          },
        },
      },
      MuiNativeSelect: {
        styleOverrides: {
          select: {
            padding: '8px',
          },
        },
      },
      MuiTooltip: {
        styleOverrides: {
          tooltip: {
            fontSize: '16px',
            maxWidth: '500px',
            whiteSpace: 'pre-wrap',
          },
        },
      },
      MuiAvatar: {
        styleOverrides: {
          root: {
            border:
              mode === 'dark'
                ? '1px solid rgba(255, 255, 255, 0.3)'
                : '1px solid rgba(0, 0, 0, 0.25)',
          },
        },
      },
    },
  })
}

const medicalTheme = createMedicalTheme('light')

export default medicalTheme
